export default __webpack_public_path__ + "static/media/manual09.b8bc2033.png";